import React from 'react';
import { Edit2, Trash2, FolderTree, FolderPlus } from 'lucide-react';
import styles from './WikiCategoriesManager.module.css';
const WikiCategoryCard = ({
  category,
  level = 0,
  reorderMode = false,
  onEdit,
  onDelete,
  onAddSubcategory,
  onOpenMoveModal,
}) => {
  const showMoveButton = reorderMode && Boolean(onOpenMoveModal);
  return (
    <div className={styles.card}>
      <div className={styles.cardIcon}>
        <FolderTree size={24} />
      </div>

      <div className={styles.cardBody}>
        <div className={styles.cardName}>{category.name}</div>
        <div className={styles.cardId}>ID: {category.id}</div>

        {showMoveButton && (
          <button
            type="button"
            className={styles.touchMoveButton}
            onClick={(e) => {
              e.stopPropagation();
              onOpenMoveModal?.(category);
            }}
            aria-label="Позиция перемещения"
            title="Позиция перемещения"
          >
            Позиция
          </button>
        )}
      </div>

      <div className={styles.cardActions}>
        {!reorderMode && onAddSubcategory && (
          <button
            type="button"
            onClick={() => onAddSubcategory(category)}
            className={styles.actionButton}
            title="Добавить подкатегорию"
          >
            <FolderPlus size={16} />
          </button>
        )}

        <button
          type="button"
          onClick={() => onEdit(category)}
          className={styles.actionButton}
          title="Редактировать"
        >
          <Edit2 size={16} />
        </button>

        <button
          type="button"
          onClick={() => onDelete(category)}
          className={`${styles.actionButton} ${styles.deleteButton}`}
          title="Удалить"
        >
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  );
};

export default WikiCategoryCard;
